import {SetStateAction, Dispatch} from 'react'
import {handleEsc} from '../../lib'
import {selectTheme} from '../../store'
import {Legend, ButtonCancel, TextLink, Button} from '..'

export interface PopupConfirmUnarchiveTaskPropsT {
  closeAction: Dispatch<SetStateAction<boolean>>
  unarchiveAction: () => void
}

export const PopupConfirmUnarchiveTask = (props: PopupConfirmUnarchiveTaskPropsT) => {
  const {color} = selectTheme()

  const {closeAction, unarchiveAction} = props

  const handleCloseAction = () => {
    if (closeAction) closeAction(false)
  }

  const handleUnarchiveAction = () => {
    if (unarchiveAction) unarchiveAction()
  }

  handleEsc(handleCloseAction)

  const TaskUnarchiveNotice = () => {
    return (
      <>
        <div>Unarchiving this task means you’ll be able to edit it again.</div>
        <div>Once you update the project, it will reappear in participants’ apps at the scheduled time.</div>
      </>
    )
  }

  return (
    <div
      data-testid='task_confirm_delete_pop'
      css={{
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        background: '#00000040',
        zIndex: 99999,
      }}>
      <div
        css={{
          position: 'absolute',
          top: 'calc(50vh - 145px)',
          left: 'calc(50vw - 300px)',
          width: '600px',
          borderRadius: '5px',
          padding: '30px',
          background: color.white,
        }}>
        <div
          css={{
            display: 'flex',
            alignItems: 'top',
            justifyContent: 'space-between',
            position: 'relative',
          }}>
          <Legend
            css={{
              marginBottom: '16px',
            }}>
            Unarchive this task
          </Legend>

          <ButtonCancel onClick={handleCloseAction} size={'large'} />
        </div>
        {TaskUnarchiveNotice()}
        {/* divider */}
        <div
          css={{
            width: '100%',
            height: '1px',
            background: color.grey_60,
            marginTop: '32px',
            marginBottom: '20px',
          }}></div>
        <div
          css={{
            width: '100%',
            display: 'flex',
            justifyContent: 'right',
          }}>
          <Button
            onClick={handleCloseAction}
            btnPadding='large'
            btnColor='grey_20'
            textColor={color.grey_600}
            children={'Cancel'}
          />
          <div css={{width: '12px'}} />
          <Button
            onClick={handleUnarchiveAction}
            btnPadding='large'
            btnColor='primary'
            children={'Unarchive And Edit Task'}
          />
        </div>
      </div>
    </div>
  )
}
